import { render, staticRenderFns } from "./MenuSummary.vue?vue&type=template&id=fb303768&scoped=true"
import script from "./MenuSummary.vue?vue&type=script&lang=js"
export * from "./MenuSummary.vue?vue&type=script&lang=js"
import style0 from "./MenuSummary.vue?vue&type=style&index=0&id=fb303768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb303768",
  null
  
)

export default component.exports